import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { map } from "rxjs/operators";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { constantUrl } from "src/app/Shared/constantUrl";
import { LmsService } from "../../services/lms.service";
declare var $: any;

@Component({
    selector: "app-main-card-info",
    templateUrl: "./main-card-info.component.html",
    styleUrls: ["./main-card-info.component.scss"],
    standalone: false
})
export class MainCardInfoComponent implements OnInit, OnDestroy {
  @Input() loanId: any;
  @Input() index?: any;
  resData: any;
  applicationId: any;
  object = Object;
  AssetsAttachment: any[] = [];
  DocModel: any;
  ApplicationNumber: any;
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  isLoaded = false;
  isMobile: boolean = false;
  modalId: string;

  modalIdSelector: string;

  constructor(
    private LmsService: LmsService,
    private router: ActivatedRoute,
    private _EncrDecrService: EncrDecrService,
    private cdRef: ChangeDetectorRef
  ) {
    this.checkMobile();
    this.router.paramMap.subscribe((param: ParamMap) => {
      if (this.loanId == null) {
        this.loanId = Number(
          this._EncrDecrService.decrypt(decodeURIComponent(param.get("id")))
        );
      }
    });
  }

  private checkMobile(): void {
    this.isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  }

  ngOnInit(): void {
    this.checkMobile();
    // Generate globally unique ID for this instance to prevent collisions
    const randomId = Math.random().toString(36).substring(2, 9);
    this.modalId = `CAMReport_${randomId}`;
    this.modalIdSelector = `#${this.modalId}`;
  }


  ngOnDestroy(): void {
    // Clean up event listeners when component is destroyed
    if (this.modalIdSelector) {
      $(this.modalIdSelector).off('hidden.bs.modal');
      $(this.modalIdSelector).off('show.bs.modal');
      console.log('Cleaned up modal events for', this.modalIdSelector);
    }
  }

  showCamReport() {
    if (this.isLoaded) {
      console.log('Already loaded — skipping fetch, just showing modal');
      $(this.modalIdSelector).modal('show');
      return;
    }

    this.isLoaded = true;
    console.log('Opening CAM Report modal | ID:', this.modalIdSelector, '| loanId:', this.loanId);

    // Listen for modal being hidden (ESC, backdrop click, or manual close)
    $(this.modalIdSelector).on('hidden.bs.modal', (e: any) => {
      // Ignore if a child/nested modal (like CIBIL Report or Experian Report) closed
      if (e && e.target && e.target !== $(this.modalIdSelector)[0]) {
        console.log('Child modal closed, keeping CAM Report open');
        if ($('.modal:visible').length > 0 || $(this.modalIdSelector).hasClass('show') || $(this.modalIdSelector).is(':visible')) {
          $('body').addClass('modal-open');
        }
        return;
      }
      console.log('CAM Modal hidden (ESC/backdrop/close) → resetting state');
      this.isLoaded = false;
      this.resData = null;
      this.cdRef.detectChanges();
      $(this.modalIdSelector).off('hidden.bs.modal');
    });

    // Show the modal immediately (UI feedback)
    $(this.modalIdSelector).modal('show');
    $(this.modalIdSelector).css('z-index', '1050');

    // Fetch data
    this.LmsService.LMS_Get_Loan_Card_Info({ LoanId: this.loanId })
      .pipe(
        map((res: any) => {
          this.AssetsAttachment = res.Item17;

          const data: any = {};
          for (let item of res?.Item2 || []) data[item.CustomerId] = { Item2: item };
          // for (let item of res?.Item3 || []) data[item.CRC_CustomerId].Item3 = item;
          for (let item of res?.Item3 || [])
            data[item.CRC_CustomerId].Item3 = data[item.CRC_CustomerId].Item3
              ? [...data[item.CRC_CustomerId].Item3, item]
              : [item];
          for (let item of res?.Item4 || [])
            data[item.CustomerId].Item4 = data[item.CustomerId].Item4
              ? [...data[item.CustomerId].Item4, item]
              : [item];
          for (let item of res?.Item5 || [])
            data[item.Customer_Id].Item5 = data[item.Customer_Id].Item5
              ? [...data[item.Customer_Id].Item5, item]
              : [item];
          for (let item of res?.Item6 || [])
            data[item.CR_CustomerId].Item6 = data[item.CR_CustomerId].Item6
              ? [...data[item.CR_CustomerId].Item6, item]
              : [item];
          for (let item of res?.Item9 || [])
            data[item.KYC_CustomerId].Item9 = data[item.KYC_CustomerId].Item9
              ? [...data[item.KYC_CustomerId].Item9, item]
              : [item];
          for (let item of res?.Item10 || [])
            data[item.CustomerId].Item10 = data[item.CustomerId].Item10
              ? [...data[item.CustomerId].Item10, item]
              : [item];
          for (let item of res?.Item11 || [])
            data[item.TVR_CusrtomerId].Item11 = data[item.TVR_CusrtomerId].Item11
              ? [...data[item.TVR_CusrtomerId].Item11, item]
              : [item];
          for (let item of res?.Item12 || [])
            data[item.Customer_Id].Item12 = data[item.Customer_Id].Item12
              ? [...data[item.Customer_Id].Item12, item]
              : [item];
          for (let item of res?.Item13 || [])
            data[item.CustomerName].Item13 = data[item.CustomerName].Item13
              ? [...data[item.CustomerName].Item13, item]
              : [item];

          const arr: any[] = [];
          Object.keys(data).forEach((x) => arr.push(data[x]));

          arr.sort((a: any, b: any) => {
            if (a.Item2.AC_CustomerType == "H") return -7;
            if (a.Item2.AC_CustomerType == "C" && b.Item2.AC_CustomerType == "H") return 1;
            if (a.Item2.AC_CustomerType == "C" && b.Item2.AC_CustomerType == "G") return -1;
            if (a.Item2.AC_CustomerType == "G") return 877;
            return 0;
          });

          return {
            Item1: res?.Item1,
            data: arr,
            asset: res?.Item7,
            goldAsset: res?.Item20,
            deviation: res?.Item14,
            sanction: res?.Item15,
            Item16: res?.Item16,
            AssetsAttachment: res?.Item17,
            documents: res?.Item18,
            ApplicationNumber: res?.Item1,
            LegalAssets: res?.Item26,
            ValuationAssestsDetails: res?.Item27,
            ValuationAttachments: res?.Item28,
            recommendation: res?.Item29
          };
        })
      )
      .subscribe({
        next: (response) => {
          this.resData = response;
          console.log("this.resData", this.resData);
          this.applicationId = response?.Item1?.[0]?.Application_No;
          this.cdRef.detectChanges();
        },
        error: (err) => {
          console.error('Error loading CAM report:', err);
          this.isLoaded = false;
          this.cdRef.detectChanges();
        }
      });
  }

  OnClose() {
    console.log('Manual close called');
    $(this.modalIdSelector).modal('hide');
    // Bootstrap should handle body/modal-backdrop removal
    // If not, you can uncomment this fallback:
    // setTimeout(() => {
    //   $('body').removeClass('modal-open');
    //   $('.modal-backdrop').remove();
    // }, 300);
  }

  removeFileAttachment(i: any) {
    this.DocModel?.splice(i, 1);
    this.AssetsAttachment?.splice(i, 1);
  }

  get borrowerName(): string {
    if (this.resData?.data?.length) {
      const primary = this.resData.data.find(
        (x: any) => x?.Item2?.AC_CustomerType === 'H'
      ) || this.resData.data[0];
      if (primary?.Item2?.Customer_Name) {
        return primary.Item2.Customer_Name;
      }
    }
    return (
      this.resData?.Item1?.[0]?.Customer_Name ||
      this.resData?.Item1?.[0]?.BorrowerName ||
      this.resData?.Item1?.[0]?.CustomerName ||
      ''
    );
  }

  get applicationNumber(): string {
    return (
      this.applicationId ||
      this.resData?.Item1?.[0]?.Application_No ||
      this.resData?.Item1?.[0]?.ApplicationNo ||
      ''
    );
  }
}